import { Combobox } from '@base-ui/react/combobox';
import { type RefObject } from 'react';
import { DropdownSkeletonLoader } from '#components/Input/Dropdown/components/DropdownSkeletonLoader';
import { useDropdownContext } from '../../context/DropdownContext';
import { VirtualizedDropdownRows } from './VirtualizedDropdownRows';
import { styles } from './styles';
import type { Virtualizer } from '@tanstack/react-virtual';

type DropdownPopupProps = {
  containerRef: RefObject<HTMLDivElement | null>;
  virtualizerRef: RefObject<Virtualizer<HTMLDivElement, Element> | null>;
};

export function DropdownPopup({ containerRef, virtualizerRef }: DropdownPopupProps) {
  const { loading } = useDropdownContext();

  if (loading) {
    return (
      <Combobox.Portal>
        <Combobox.Positioner css={styles.Positioner} anchor={containerRef}>
          <Combobox.Popup css={styles.Popup}>
            <Combobox.List css={styles.List}>
              <DropdownSkeletonLoader />
            </Combobox.List>
          </Combobox.Popup>
        </Combobox.Positioner>
      </Combobox.Portal>
    );
  }

  return (
    <Combobox.Portal>
      <Combobox.Positioner css={styles.Positioner} anchor={containerRef}>
        <Combobox.Popup css={styles.Popup}>
          <Combobox.List css={styles.List}>
            <VirtualizedDropdownRows virtualizerRef={virtualizerRef} />
          </Combobox.List>
        </Combobox.Popup>
      </Combobox.Positioner>
    </Combobox.Portal>
  );
}
